<template>
    <card title="Horizontal Form">
        <h4 slot="header" class="card-title">
            雲市集資料匯入
        </h4>

        <div class="container-fluid">
            <div class="row align-items-center">
                <div class="col-md-9">
                <form id="fileUploadForm" class="form-inline d-flex align-items-center" @submit.prevent="uploadFileTemp">
                    <label for="fileInput" class="form-label mr-2" style="font-size: 14px;">選擇要上傳的文件</label>
                    <div class="col-md-4">
                        <input type="file" @change="handleFileUpload" ref="fileInput" class="form-control-file mb2">
                    </div>
                </form>
                </div>
                <div class="col-md-3 d-flex justify-content-end">
                    <button type="submit" form="fileUploadForm" class="btn btn-primary">預覽文件內容</button>
                    <button class="btn btn-warning" @click="downloadTemplate">下載文件範例</button>
                </div>
            </div>

            <div class="row mt-4">
                <h4>表單內容</h4>
            </div>

            <div class="btn-container" style="display: flex; justify-content: space-between; align-items: center;">
                <div class="btn-group">
                    <button 
                        :class="['btn', currentSheet === 'orderDataTemp' ? 'btn-primary' : 'btn']" 
                        @click="currentSheet = 'orderDataTemp'">
                        list (訂單資料)
                    </button>
                    <button 
                        :class="['btn', currentSheet === 'loginDataTemp' ? 'btn-primary' : 'btn']" 
                        @click="currentSheet = 'loginDataTemp'">
                        data (登入資料)
                    </button>
                </div>

                <div>
                    <button type="submit" class="btn btn-danger" @click="uploadDataToDatabase" :disabled="isUploadDisabled">上傳</button>
                    <button class="btn btn-warning" @click="downloadUploadResults" v-if="showDownloadStatusLink">下載上傳結果</button>
                </div>
            </div>
        </div>
        

        <div>
            <data-tables :data="orderDataTemp" v-if="currentSheet === 'orderDataTemp'">
                <el-table-column type="index" label="#" width="50"></el-table-column>
                <el-table-column prop="訂單編號" label="訂單編號"></el-table-column>
                <el-table-column prop="中小企業名稱" label="中小企業名稱"></el-table-column>
                <el-table-column prop="店名" label="店名"></el-table-column>
                <el-table-column prop="採購方案" label="採購方案"></el-table-column>
                <el-table-column prop="商店ID" label="商店ID"></el-table-column>
            </data-tables>
            
            <data-tables :data="loginDataTemp" v-if="currentSheet === 'loginDataTemp'">
                <el-table-column type="index" label="#" width="50"></el-table-column>
                <el-table-column prop="登入時間" label="登入時間"></el-table-column>
                <el-table-column prop="訂單編號" label="訂單編號"></el-table-column>
                <el-table-column prop="中小企業名稱" label="中小企業名稱"></el-table-column>
                <el-table-column prop="店名" label="店名"></el-table-column>
                <el-table-column prop="採購方案" label="採購方案"></el-table-column>
                <el-table-column prop="商店ID" label="商店ID"></el-table-column>
            </data-tables>
        </div>
    </card>
</template>
  
<script>
import axios from "axios";

export default {
    data() {
        return {
            fileName: '',
            orderDataTemp: [],
            loginDataTemp: [],
            currentSheet: 'orderDataTemp',
            showDownloadStatusLink: false,
        };
    },
    methods: {
        handleFileUpload(event) {
            const file = event.target.files[0];
            this.fileName = file ? file.name : '';
        },

        async uploadFileTemp() {
                if (!this.fileName) {
                    alert('請選擇一個檔案');
                return;
            }
    
            const fileInput = this.$refs.fileInput;

            if (fileInput && fileInput.files[0]) {
                const formData = new FormData();
                formData.append('file', fileInput.files[0]);
    
                try {
                    const response = await axios.post(
                        `${process.env.VUE_APP_APIHOST}/gaa/cloud-market/excel-temp`,
                        formData,
                        {
                            headers: {
                                'Content-Type': 'multipart/form-data',
                            },
                            timeout: 1000 * 60,
                        }

                    );
                    this.orderDataTemp = response.data.orderDataTemp;
                    this.loginDataTemp = response.data.loginDataTemp;

                } catch (error) {
                    this.orderDataTemp = [];
                    this.loginDataTemp = [];

                    const errorMessage = error.data && error.data.message 
                        ? error.data.message 
                        : '預覽失敗';
                    console.error(error);
                    alert(errorMessage);
                }
            }
        },

        async uploadDataToDatabase() {
            try {
                const response = await axios.post(
                    `${process.env.VUE_APP_APIHOST}/gaa/cloud-market/excel`,
                    {},
                    {
                        timeout: 1000 * 300,
                    }
                );
                this.showDownloadStatusLink = true;
                alert(response.data.message);

            } catch (error) {
                this.showDownloadLink = true;
                alert('上傳失敗: ' + error.data.message);
            }
        },

        downloadUploadResults() {
            const url = `${process.env.VUE_APP_APIHOST}/gaa/cloud-market/excel-status`;
            window.open(url, '_blank');
        },

        downloadTemplate() {
            const url = `${process.env.VUE_APP_APIHOST}/gaa/cloud-market/excel-template`;
            window.open(url, '_blank');
        }
    },
    computed: {
        isUploadDisabled() {
            return this.orderDataTemp.length === 0 && this.loginDataTemp.length === 0;
        },
    }
};
</script>